import VMLogo from '@/assets/branding/volunteermckinney/VM.png';

const colors = {
  // Brand colors
  brand_primary: '#12229D',
  brand_primary_hover: '#121C6A', // −10 L, −8 S
  brand_primary_highlight: '#344AF0', // +23 L, +7 S
  brand_primary_mid: '#1428C4', // +8 L,  +2 S
  brand_primary_dark: '#060A2A', // −25 L, −3 S
  brand_secondary: '#111452', // hue +4°, −15 L, −13 S
  brand_accent_start: '#1E35CB',
  brand_accent_end: '#6E5AE4',
  brand_accent_light_start: '#E9ECFB',
  brand_accent_light_end: '#EEEBFF',
  brand_complementary_accent: 'rgb(219,167,18)',
  brand_auth_gradient_mid: '#111452',
  brand_auth_gradient_end: '#060A2A',
  brand_auth_warp_mid: '#1428C4',
};

export default {
  name: 'Volunteer Mckinney',
  isSAML: true,
  allowPersonalCourses: false,
  logo: VMLogo,
  colors,
};
